module.exports = __webpack_public_path__ + "img/PPMPprint3.b819a8b8.png";